import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that checks if the current URL path corresponds to a firm page
 * Firm URLs follow the pattern: /firms/:firmSlugParam/:tableSlugParam
 * 
 * @returns {boolean} True if the current path is a firm path, false otherwise
 */
export const useIsFirmPath = (): boolean => {
  const { pathname } = useLocation();

  const isFirmPath = useMemo(
    () => !pathname.includes('/companies/') && !pathname.includes('/fund-investments/'),
    [pathname]
  );

  return isFirmPath;
};
